// Exactly the four fixed rooms, each with who is inside right now. Anything
// but a readable `ok` answer shows "presença indisponível", never "vazia".
import {
  EMPTY_ROOM_LABEL,
  FIXED_ROOM_SLUGS,
  PRESENCE_UNAVAILABLE_LABEL,
} from '@kima-hub/contracts';
import type { RoomPresence } from '@kima-hub/contracts';
import { COPY } from '../copy.js';
import type { PresenceState } from '../presence/usePresence.js';
import { Link, paths } from '../router.js';
import { recordingUnavailableText } from '../ui/labels.js';

function roomOf(state: PresenceState, slug: string): RoomPresence | 'loading' | null {
  if (state.kind === 'loading') return 'loading';
  if (state.kind === 'failed') return null;
  return state.data.rooms.find((room) => room.slug === slug) ?? null;
}

export function RoomTabs({ presence, narrow }: { presence: PresenceState; narrow: boolean }) {
  return (
    <section aria-labelledby="rooms-title">
      <h2 id="rooms-title">{COPY.rooms}</h2>
      <ul className={narrow ? 'room-tabs room-tabs--stacked' : 'room-tabs'} data-testid="room-tabs">
        {FIXED_ROOM_SLUGS.map((slug) => {
          const room = roomOf(presence, slug);
          return (
            <li key={slug} className="room-tab" data-testid={`room-tab-${slug}`}>
              <div className="room-tab__head">
                <span className="room-tab__title">{slug}</span>
                <Link className="button" href={paths.room(slug)} aria-label={`${COPY.enterRoom} na sala ${slug}`}>
                  {COPY.enterRoom}
                </Link>
              </div>
              <RoomBody room={room} />
            </li>
          );
        })}
      </ul>
    </section>
  );
}

function RoomBody({ room }: { room: RoomPresence | 'loading' | null }) {
  if (room === 'loading') return <p className="muted">{COPY.loading}</p>;
  if (room === null || room.status === 'unavailable') {
    return <p className="warning">{PRESENCE_UNAVAILABLE_LABEL}</p>;
  }
  const noRecording = recordingUnavailableText(room.recording);
  return (
    <>
      {room.participants.length === 0 ? (
        <p className="muted">{EMPTY_ROOM_LABEL}</p>
      ) : (
        <ul className="names">
          {room.participants.map((p) => (
            <li key={p.person_id}>{p.display_name}</li>
          ))}
        </ul>
      )}
      {noRecording && <p className="notice">{noRecording}</p>}
    </>
  );
}
